export const BET_SLIP_BUTTON_ID = 'betslip-button'
